import { Modals, useModals } from "@/hooks/useModals"
import Modal from "@/components/Modal"
import CopyToClipboard from "react-copy-to-clipboard-ts"
import { CheckIcon, LinkIcon } from "@heroicons/react/24/outline"
import { useEffect, useState } from "react"
import Button from "@/components/Button"
import { usePage } from "@inertiajs/react"
import { GameShowProps } from "@/types/types"

const EmbedModal = () => {
  const { game } = usePage<GameShowProps>().props
  const { activeModal, closeModal } = useModals()
  const isOpen = activeModal === Modals.EmbedGame
  const [copied, setCopied] = useState(false)

  useEffect(() => {
    const timeout = setTimeout(() => setCopied(false), 1000)
    return () => clearTimeout(timeout)
  }, [copied])

  const code = `<iframe src="https://chessdrop.com/embed/${game.id}" width="100%" height="830" loading="lazy"></iframe>`

  return (
    <Modal show={isOpen} onClose={closeModal} title="Embed game">
      <div className="pt-4">
        <p className="font-medium text-gray-500">
          Copy the code below to embed this chess game on your website. The game
          is fully interactive, so your visitors can replay and explore it move
          by move.
        </p>
        <div className="prose mt-4">
          <pre>
            <code>{code}</code>
          </pre>
        </div>
        <CopyToClipboard text={code} onCopy={() => setCopied(true)}>
          <Button fullWidth full style="secondary" className="mt-4">
            {copied ? (
              <>
                <CheckIcon className="mr-1 h-5 w-5 shrink-0" />
                <span>Code copied!</span>
              </>
            ) : (
              <>
                <LinkIcon className="mr-1 h-5 w-5 shrink-0" />
                <span>Copy code</span>
              </>
            )}
          </Button>
        </CopyToClipboard>
      </div>
    </Modal>
  )
}

export default EmbedModal
